import logger from "@airhelp/node-logger";
import type { LanguageCode } from "config/languages";
import getRegularPageUrl from "./getRegularPageUrl";
import getStoryblokPageUrl from "./getStoryblokPageUrl";
import type { PageName } from "./types";
import { REGULAR_PAGES, STORYBLOK_PAGES } from "./types";

export const getPageUrl = (language: LanguageCode, pageName: PageName) => {
  if (([...REGULAR_PAGES] as PageName[]).includes(pageName)) return getRegularPageUrl(language, pageName);

  if (([...STORYBLOK_PAGES] as PageName[]).includes(pageName)) return getStoryblokPageUrl(language, pageName);

  logger.error(`Unknown pageName used in getPageUrl(${language}, ${pageName}).`);

  return "/";
};
